import { hydrateRoot } from 'react-dom/client';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { RelayEnvironmentProvider } from 'react-relay';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500.tsx';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider.ts';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.ts';
import { ServerVarsContextProvider } from '../utils/ServerVarsContext.tsx';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout.tsx';
import { trackPageview } from 'dibs-tracking';

import { paths } from '../nftPublicProfile/constants.ts';
import { NftPublicProfileRespLayout } from '../nftPublicProfile/profile/NftPublicProfileRespLayout.tsx';
import { nftPublicProfileEntryQuery } from '../nftPublicProfile/profile/nftPublicProfileEntryQuery.ts';

import { type NftHeaderLayout_viewer$key as NftHeaderLayoutViewer } from '../nftHeader/__generated__/NftHeaderLayout_viewer.graphql.ts';
import { type NftPublicProfileRespLayout_viewer$key as NftPublicProfileViewer } from '../nftPublicProfile/profile/__generated__/NftPublicProfileRespLayout_viewer.graphql.ts';

const locale = serverVars.get('locale');
const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
    ...serverVars.get('relay.relayData'),
});

const variables = serverVars.get('relay.variables');

const operation = createOperationDescriptor(getRequest(nftPublicProfileEntryQuery), variables);
const snapshot = environment.lookup(operation.fragment);
environment.retain(operation);

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={locale}>
            <ServerVarsContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
            >
                <RelayEnvironmentProvider environment={environment}>
                    <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
                        <Router basename={`${paths.profileUser}${variables?.username}`}>
                            <Provider store={store}>
                                <DibsWeb3ReactProvider>
                                    <NftHeaderLayout
                                        viewer={snapshot.data.viewer as NftHeaderLayoutViewer}
                                    >
                                        <NftPublicProfileRespLayout
                                            viewer={snapshot.data.viewer as NftPublicProfileViewer}
                                        />
                                    </NftHeaderLayout>
                                </DibsWeb3ReactProvider>
                            </Provider>
                        </Router>
                    </ErrorBoundary>
                </RelayEnvironmentProvider>
            </ServerVarsContextProvider>
        </IntlProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Results',
            pageSubType: 'NFT Profile',
        },
    });
});
